import { render, staticRenderFns } from "./topWheel.vue?vue&type=template&id=13c88282&scoped=true"
import script from "./topWheel.vue?vue&type=script&lang=js"
export * from "./topWheel.vue?vue&type=script&lang=js"
import style0 from "./topWheel.vue?vue&type=style&index=0&id=13c88282&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "13c88282",
  null
  
)

export default component.exports